import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "col-md-12" }
const _hoisted_2 = {
  class: "d-flex align-items-center flex-wrap gap-3",
  style: {"margin-left":"10px"}
}
const _hoisted_3 = {
  key: 1,
  class: "text-muted fw-semibold"
}
const _hoisted_4 = { class: "form-check mb-0" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = ["onClick"]
const _hoisted_7 = ["onClick"]
const _hoisted_8 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ConsulteGrid = _resolveComponent("ConsulteGrid")!
  const _component_ModalCadastroEdicao = _resolveComponent("ModalCadastroEdicao")!
  const _component_ModalDevolucao = _resolveComponent("ModalDevolucao")!
  const _component_ModalRenovacao = _resolveComponent("ModalRenovacao")!
  const _component_ModalComprovante = _resolveComponent("ModalComprovante")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_ConsulteGrid, {
      columns: _ctx.rows,
      "data-source": _ctx.dataSource,
      actions: true,
      "show-views-manager": false,
      "show-filter-button": false,
      "show-column-selection-button": false,
      "show-applied-filters": false,
      onOnChangeDataRow: _ctx.rowChange
    }, {
      header: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          (_ctx.permissaoTela.incluir)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                type: "button",
                class: "btn btn-primary rounded-pill",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.abrirCadastroPopup && _ctx.abrirCadastroPopup(...args)))
              }, [...(_cache[6] || (_cache[6] = [
                _createElementVNode("i", {
                  class: "uil uil-plus",
                  "aria-hidden": "true"
                }, null, -1),
                _createTextVNode("Cadastrar ", -1)
              ]))]))
            : _createCommentVNode("", true),
          (_ctx.nomeUsuarioSelecionado)
            ? (_openBlock(), _createElementBlock("span", _hoisted_3, " Usuário: " + _toDisplayString(_ctx.nomeUsuarioSelecionado), 1))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_4, [
            _withDirectives(_createElementVNode("input", {
              id: "somenteNaoDevolvido",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.somenteNaoDevolvido) = $event)),
              class: "form-check-input",
              type: "checkbox",
              onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.aplicarFiltroSomenteNaoDevolvido && _ctx.aplicarFiltroSomenteNaoDevolvido(...args)))
            }, null, 544), [
              [_vModelCheckbox, _ctx.somenteNaoDevolvido]
            ]),
            _cache[7] || (_cache[7] = _createElementVNode("label", {
              class: "form-check-label",
              for: "somenteNaoDevolvido"
            }, "Somente não Devolvido", -1))
          ]),
          _cache[8] || (_cache[8] = _createElementVNode("div", { class: "d-flex align-items-center flex-wrap gap-2" }, [
            _createElementVNode("span", { class: "d-inline-flex align-items-center text-muted small" }, [
              _createElementVNode("span", {
                class: "rounded-circle d-inline-block me-1",
                style: {"width":"10px","height":"10px","background-color":"#dc3545"}
              }),
              _createTextVNode(" Entrega Atrazada ")
            ]),
            _createElementVNode("span", { class: "d-inline-flex align-items-center text-muted small" }, [
              _createElementVNode("span", {
                class: "rounded-circle d-inline-block me-1",
                style: {"width":"10px","height":"10px","background-color":"#0d6efd"}
              }),
              _createTextVNode(" Devolvido ")
            ])
          ], -1))
        ])
      ]),
      titulo: _withCtx((context) => [
        _createElementVNode("span", {
          style: _normalizeStyle({ color: _ctx.getStatusColor(context.row) })
        }, _toDisplayString(context.row.titulo), 5)
      ]),
      autoria: _withCtx((context) => [
        _createElementVNode("span", {
          style: _normalizeStyle({ color: _ctx.getStatusColor(context.row) })
        }, _toDisplayString(context.row.autoria), 5)
      ]),
      dataEmprestimo: _withCtx((context) => [
        _createElementVNode("span", {
          style: _normalizeStyle({ color: _ctx.getStatusColor(context.row) })
        }, _toDisplayString(_ctx.formatDate(context.row.dataEmprestimo)), 5)
      ]),
      dataVencimento: _withCtx((context) => [
        _createElementVNode("span", {
          style: _normalizeStyle({ color: _ctx.getStatusColor(context.row) })
        }, _toDisplayString(_ctx.formatDate(context.row.dataVencimento)), 5)
      ]),
      dataDevolucao: _withCtx((context) => [
        _createElementVNode("span", {
          style: _normalizeStyle({ color: _ctx.getStatusColor(context.row) })
        }, _toDisplayString(_ctx.formatDate(context.row.dataDevolucao)), 5)
      ]),
      botaoDevolucao: _withCtx((context) => [
        (_ctx.permissaoTela.alterar && !_ctx.isDevolvido(context.row))
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              type: "button",
              class: "btn btn-outline-warning",
              onClick: ($event: any) => (_ctx.devolverExemplar(context.row))
            }, " Devolver ", 8, _hoisted_5))
          : (_ctx.permissaoTela.alterar)
            ? (_openBlock(), _createElementBlock("button", {
                key: 1,
                type: "button",
                class: "btn btn-outline-danger",
                onClick: ($event: any) => (_ctx.cancelarDevolucao(context.row))
              }, " Cancelar ", 8, _hoisted_6))
            : _createCommentVNode("", true)
      ]),
      botaoRenovar: _withCtx((context) => [
        (_ctx.permissaoTela.alterar && !_ctx.isDevolvido(context.row))
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              type: "button",
              class: "btn btn-outline-warning",
              onClick: ($event: any) => (_ctx.renovarExemplar(context.row))
            }, " Renovar ", 8, _hoisted_7))
          : _createCommentVNode("", true)
      ]),
      botaoEditar: _withCtx((context) => [
        ((_ctx.permissaoTela.alterar || _ctx.permissaoTela.excluir) && !_ctx.isDevolvido(context.row))
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              type: "button",
              class: "btn btn-outline-warning",
              onClick: ($event: any) => (_ctx.editarExemplar(context.row))
            }, " Editar ", 8, _hoisted_8))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["columns", "data-source", "onOnChangeDataRow"]),
    _createVNode(_component_ModalCadastroEdicao, {
      ref: "modalCadastroEdicao",
      onSaved: _ctx.recarregarGrid,
      onComprovante: _cache[3] || (_cache[3] = ($event: any) => (_ctx.abrirComprovante($event, 'emprestimo')))
    }, null, 8, ["onSaved"]),
    _createVNode(_component_ModalDevolucao, {
      ref: "modalDevolucao",
      onSaved: _ctx.recarregarGrid,
      onComprovante: _cache[4] || (_cache[4] = ($event: any) => (_ctx.abrirComprovante($event, 'devolucao')))
    }, null, 8, ["onSaved"]),
    _createVNode(_component_ModalRenovacao, {
      ref: "modalRenovacao",
      onSaved: _ctx.recarregarGrid,
      onComprovante: _cache[5] || (_cache[5] = ($event: any) => (_ctx.abrirComprovante($event, 'renovacao')))
    }, null, 8, ["onSaved"]),
    _createVNode(_component_ModalComprovante, { ref: "modalComprovante" }, null, 512)
  ]))
}